export default class AzureConfigStore {
  useB2c: boolean;
  clientId: string;
  redirectUri: string;
  scopes: string[];
  policies: any;
  forgotPwdUrl: string;

  constructor(config: any) {
    this.useB2c = config.USE_B2C;
    this.clientId = config.CLIENT_ID;
    this.redirectUri = config.REDIRECT_URI;
    this.scopes = config.SCOPES;
    this.policies = config.POLICIES;
    this.forgotPwdUrl = config.FORGOT_PWD_URL;
  }

  getUseB2c() {
    return this.useB2c;
  }

  getClientId() {
    return this.clientId;
  }

  getRedirectUri() {
    return this.redirectUri;
  }

  getScopes() {
    return this.scopes;
  }

  getPolicies() {
    return this.policies;
  }

  getForgotPwdUrl() {
    return this.forgotPwdUrl;
  }
}
